import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-m-cities',
  templateUrl: './edit-m-cities.component.html',
  styleUrls: ['./edit-m-cities.component.scss']
})
export class EditMCitiesComponent implements OnInit {

  formData: any = {
    name_ar: '',
    name_en: '',
    country_id: ''
  };

  countries: any[] = [];
  cityId: string = ''; // تهيئة بقيمة افتراضية
  currentLang: string = 'en';
  isLoading: boolean = false; // إضافة مؤشر تحميل
  isSubmitting: boolean = false; // منع إرسال متعدد

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.currentLang = this.translate.currentLang || 'en';
  }

  ngOnInit(): void {
    // الحصول على ID من الـ route parameters بشكل آمن
    this.cityId = this.route.snapshot.paramMap.get('id') || '';
    
    if (!this.cityId) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.invalid_city_id'));
      this.router.navigate(['/m-cities']);
      return;
    }
    
    this.getCountries();
  }

  getCountries(): void {
    // this.isLoading = true;
    this.apiService.getCountriesM().subscribe({ 
      next: (response: any) => { 
        this.countries = response.data || [];
        // بعد تحميل الدول، احصل على بيانات المدينة
        this.getCityData();
      }, 
      error: (err) => { 
        console.error('Error in fetching countries', err);
        this.isLoading = false;
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_countries'));
      }
    });
  }

getCityData() {
  if (this.cityId) {
    this.apiService.getCitiesById(this.cityId).subscribe({
      next: (response: any) => {
        this.formData = {
          name_ar: response.data?.name || '',   // ← API field name
          name_en: response.data?.name_en || '', // if not provided leave empty
          country_id: response.data?.country_id || ''
        };
      },
      error: (err) => {
        console.error('Get city failed:', err);
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_city'));
      }
    });
  }
}


  onSubmit(): void {
    if (!this.cityId) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.invalid_city_id'));
      return;
    }

    const form = new FormData();
    form.append('name_en', this.formData.name_en);
    form.append('name_ar', this.formData.name_ar);
    form.append('country_id', this.formData.country_id);
    
    this.apiService.editCity(this.cityId, form).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('MENU.DASHBOARD.cities_edit_successfully'));
        this.router.navigate(['/m-cities']);
      },
      error: (err) => {
        console.error('Get city failed:', err);
        this.isLoading = false;
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_city'));
      }
    });
  }

//  onSubmit(): void {
//   if (!this.isFormValid()) {
//     this.toastr.error(this.translate.instant('MENU.DASHBOARD.please_fill_all_required_fields'));
//     return;
//   }

//   if (!this.cityId || this.isSubmitting) {
//     return;
//   }

//   this.isSubmitting = true;

//   const payload = {
//     name_en: this.formData.name_en,
//     name_ar: this.formData.name_ar,
//     country_id: this.formData.country_id
//   };
  
//   this.apiService.editCity(this.cityId, payload).subscribe({
//     next: () => {
//       this.toastr.success(this.translate.instant('MENU.DASHBOARD.cities_edit_successfully'));
//       this.router.navigate(['/m-cities']);
//       this.isSubmitting = false;
//     },
//     error: (err) => {
//       console.error('Edit city failed:', err);
//       this.toastr.error(this.getErrorMessage(err));
//       this.isSubmitting = false;
//     }
//   });
// }

  // دالة للتحقق من صحة النموذج
  private isFormValid(): boolean {
    return !!(
      this.formData.name_ar?.trim() && 
      this.formData.name_en?.trim() && 
      this.formData.country_id
    );
  }

  // دالة للحصول على رسالة الخطأ
  private getErrorMessage(err: any): string {
    if (err.error?.message) {
      return err.error.message;
    }
    return this.translate.instant('MENU.DASHBOARD.failed_to_edit_cities');
  }

  cancel(): void {
    if (!this.isSubmitting) {
      this.router.navigate(['/m-cities']);
    }
  }
}